import React, { useEffect } from 'react';
import styled from 'styled-components';
import { withUser } from '@modules/auth';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Preloader } from 'planoplan-ui-kit/core/preloader';
import { IErrorCircle } from 'planoplan-ui-kit/core/icons/i-error-circle';
import { getPreviewDesignProject, getPreviewScreenshots } from '@modules/get-data';
import { PreviewLayout, ui } from '@layouts';
import { Points } from '@styles';
import { TestWalkerWidget } from '@sections/Test-Walker-Widget';
import { decodeParams } from '@modules/helper';

const Preview = ({
  src = '',
  isPanorama = false,
  isTour = false,
  isEstimate = false,
  estimateData = {},
  sharedUser,
  designHtml = '',
  isTestWidget = false,
}) => {
  const isError = !designHtml && (isEstimate ? false : !src);

  useEffect(() => {
    if (designHtml) {
      // eslint-disable-next-line no-console
      console.log('PREVIEW BRANCH: DESIGN PROJECT', { length: designHtml.length });
      document.open();
      document.write(designHtml);
      document.close();

      return undefined;
    }

    if (!isError && !isTestWidget) {
      // eslint-disable-next-line no-console
      console.log('PREVIEW BRANCH: GALLERY', { src, isPanorama, isTour, isEstimate });
      ui.openPreviewGallery(src, sharedUser, { isPanorama, isTour, isEstimate, estimateData });
    }

    return () => ui.closeGallery();
  }, []);

  if (isTestWidget) {
    return <TestWalkerWidget />;
  }

  return (
    <Container id="gallery">
      {isError ? (
        <Error>
          Error
          <IErrorCircle width="228px" height="228px" stroke={Colors.colar} />
        </Error>
      ) : (
        <Preloader width="70px" height="70px" fill={Colors.main_blue} />
      )}
    </Container>
  );
};

Preview.getLayout = (page) => <PreviewLayout>{page}</PreviewLayout>;

const Container = styled.section`
  width: 100%;
  height: 100%;
  background-color: ${Colors.night};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: fixed;

  @media ${Points.tablet_landscape} {
    min-height: 650px;
  }
`;

const Error = styled.div`
  font-size: 24px;
  line-height: 28px;
  color: ${Colors.light_gray};
  text-align: center;
  display: flex;
  flex-direction: column;
`;

Preview.getInitialProps = async (ctx) => {
  const { query, store } = ctx;
  const { hash = '', tour = false, estimate = false, d = '' } = query;
  const data = decodeParams(d.replace('/', ''));

  if (hash === 'widget') {
    return { isTestWidget: true };
  }

  const { dispatch } = store;
  const designHtml = await dispatch(getPreviewDesignProject(hash));

  if (designHtml) {
    return { designHtml };
  }

  return await dispatch(
    getPreviewScreenshots(hash, {
      isTour: Boolean(tour) || Boolean(data.tour),
      isEstimate: Boolean(estimate) || Boolean(data.estimate),
      hiddenColumns: data.hidden_columns,
      hiddenTypes: data.hidden_types,
    })
  );
};

export default withUser(Preview);
